export interface IScript {
    scriptId: string;
    name: string;
    text: string;
    updateTs: number;
    error: string;
    deleting: boolean;
    type: 'script' | 'javascript' | 'transform'
}

export function isScriptType(item: IScript): boolean {
    return item.type === 'script' || item.type === 'javascript';
}